import { CVBuilderDBValues, CVBuilderFormValues } from './types';

export const transformFormToDB = (
  formValues: CVBuilderFormValues
): CVBuilderDBValues => ({
  language: formValues.language,
  personalDetails: {
    firstname: formValues.personalDetails.firstname,
    lastname: formValues.personalDetails.lastname,
    email: formValues.personalDetails.email,
    phone: formValues.personalDetails.phone,
    zip: formValues.personalDetails.zip,
    insuranceType: formValues.personalDetails.insuranceType,
    insuranceName: formValues.personalDetails.insuranceName,
    weeklyAvailableHours:
      Number(formValues.personalDetails.weeklyAvailableHours) || 16,
    stipendBafoeg: formValues.personalDetails.stipendBafoeg === 'true'
  },
  education: formValues.education.map(edu => ({
    ...edu,
    currentlyEnrolled: !!edu.currentlyEnrolled
  })),
  professionalExperience: formValues.professionalExperience.map(exp => ({
    ...exp,
    endDate: exp.currentlyWorking ? '' : exp.endDate || ''
  })),
  hardSkills: formValues.hardSkills.map(skill => ({
    ...skill,
    professionallyUsed: !!skill.professionallyUsed
  })),
  softSkills: formValues.softSkills,
  languageSkills: formValues.languageSkills,
  certificates: formValues.certificates,
  completedSteps: formValues.completedSteps || []
});

export const transformDBToForm = (
  data: CVBuilderDBValues
): CVBuilderFormValues => ({
  language: data.language,
  personalDetails: {
    ...data.personalDetails,
    weeklyAvailableHours: data.personalDetails?.weeklyAvailableHours,
    stipendBafoeg:
      data.personalDetails?.stipendBafoeg === true ? 'true' : 'false'
  },
  education: data.education,
  professionalExperience: data.professionalExperience,
  hardSkills: data.hardSkills,
  softSkills: data.softSkills,
  languageSkills: data.languageSkills,
  certificates: data.certificates,
  completedSteps: data.completedSteps || []
});
